import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function ProofSection() {
  return <section className="bg-white py-24 px-4" data-id="element-175">
      <div className="max-w-[720px] mx-auto" data-id="element-176">
        <FadeIn data-id="element-177">
          <div className="relative" data-id="element-178">
            <div className="absolute -top-6 -left-6 text-6xl text-[#E8F5E2] font-serif" data-id="element-179">
              "
            </div>
            <p className="text-2xl md:text-3xl text-[#1A1A1A] font-medium leading-relaxed text-center relative z-10" data-id="element-180">
              En los próximos 7 días, lo que cambiará no será solo el número en
              la báscula por la pérdida de líquidos retenidos;{' '}
              <span className="text-[#2D5A27]" data-id="element-181">
                será tu relación con el espejo.
              </span>
            </p>
            <p className="text-lg text-[#5A5A5A] mt-8 text-center leading-relaxed" data-id="element-182">
              Notarás que tus facciones se definen, tus tobillos ya no se
              hinchan al final del día y, por primera vez en meses, terminarás
              tu jornada laboral sin sentir que tu abdomen va a explotar.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}